import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import customBuild from "src/ckeditor5/build/ckeditor";
import {
  PaymentProviderIDs,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton, Smtp } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";
import {
  GetAdsProvidersMethod,
  SetAdsProviderMethod,
} from "src/app/core/services/outbound";
@Component({
  selector: "app-gen-appPaymentInGoogleAds-ios",
  templateUrl: "./gen-appPaymentInGoogleAds-ios.component.html",
  styleUrls: ["./gen-appPaymentInGoogleAds-ios.component.scss"],
})
export class GenAppPaymentGoogleAdsIOSComponent
  implements OnInit, OnDestroy
{
  constructor(
    private formBuilder: UntypedFormBuilder,
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private builderService: BuilderService,
  ) {}

  googleAdsform: UntypedFormGroup; // bootstrap validation form

  @Input() button_id: string;
  @Input() page_id: string;
  button: MenuButton;
  mode: string;
  public Editor = customBuild;
  // default values
  offCanvasSubscription: any;

  offcanvasColors = offcanvasColors;
  newTab = false;
  button_label: string;
  row_id: string;
  labelColor = "#ffffff";
  data: any;
  currentMenuSubscription: any;
  verifySubscription: any;
  adsProvidersSubscription: any;
  testedMessagingSubscription: any;
  thirdPartyInfoSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  component_ref: any;

  message: any;

  submitted = false;
  vendorTestSubmitted = false;

  loadding = false;

  smtpOpj: Smtp;
  app_info: any = {};
  showTest = false;
  paymentProviderIDs = PaymentProviderIDs;
  adsConfig: any;

  ngOnInit() {
    this.component_ref = this.mdw.makeRef(16);
    this.googleAdsform = this.formBuilder.group({
      active: new UntypedFormControl(0),
      ios_ad_google_key: new UntypedFormControl("", [Validators.required]),
      ios_ad_native_key: new UntypedFormControl("", [Validators.required]),
      ios_ad_banner_key: new UntypedFormControl("", [Validators.required]),
      ios_disable_banner: new UntypedFormControl(true),
      ios_disable_native: new UntypedFormControl(true),
      ios_cell_count: new UntypedFormControl(5, [Validators.required]),
      provider_id: new UntypedFormControl(this.paymentProviderIDs.INAPPGOOGLE),
    });

    this.field_id = "label";

    this.sortedButtonList = [];
    this.buttonList = {};

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      }
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];

          this.buttonFunction();
        }
      }
    );

    this.adsProvidersSubscription = this.ws.adsProvidersContainer$.subscribe(
      (data) => {
        if (data) {
          this.adsConfig = data.config ? data.config : null;
          this.googleAdsform = this.formBuilder.group({
            active: new UntypedFormControl(
              this.app_info &&
              this.app_info.ads_provider &&
              data.config &&
              data.config.ios_ad_native_key &&
              this.app_info.ads_provider ===
                this.paymentProviderIDs.GOOGLEPROVIDER
                ? 1
                : 0
            ),
            ios_ad_google_key: new UntypedFormControl(
              (data.config && data.config.ios_ad_google_key) || "",
              [Validators.required]
            ),
            ios_ad_native_key: new UntypedFormControl(
              (data.config && data.config.ios_ad_native_key) || "",
              [Validators.required]
            ),
            ios_ad_banner_key: new UntypedFormControl(
              (data.config && data.config.ios_ad_banner_key) || "",
              [Validators.required]
            ),
            ios_disable_banner: new UntypedFormControl(
              this.app_info &&
              this.app_info.ads_config_ios &&
              this.app_info.ads_config_ios.ios_disable_banner === 1
                ? false
                : true
            ),
            ios_disable_native: new UntypedFormControl(
              this.app_info &&
              this.app_info.ads_config_ios &&
              this.app_info.ads_config_ios.ios_disable_native === 1
                ? false
                : true
            ),
            ios_cell_count: new UntypedFormControl(
              (this.app_info &&
                this.app_info.ads_config_ios &&
                this.app_info.ads_config_ios.ios_cell_count) ||
                5,
              [Validators.required]
            ),
            provider_id: new UntypedFormControl(
              this.paymentProviderIDs.GOOGLEPROVIDER
            ),
          });
        }
      }
    );

    this.verifySubscription = this.ws.verifyContainer$.subscribe(
      (verifyData) => {
        // console.log("verifyData"+ verifyData);
        if (verifyData) {
          const appInfo = this.indexDBService.getItem("item", "app_info");
          appInfo.onsuccess = (event) => {
            if (appInfo.result) {
              this.app_info = appInfo.result;
              this.ws.processMethod(
                new GetAdsProvidersMethod(
                  this.paymentProviderIDs.GOOGLEPROVIDER,
                  this.component_ref
                )
              );
            }
          };
        }
      }
    );
  }

  buttonIntialize(data) {
    this.data = data.data;
    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  fileChange(event: Event) {
    const file = (event.target as HTMLInputElement).files[0]; // Here we use only the first file (single file)
    this.googleAdsform.patchValue({ file: file });
  }

  onSubmit() {
    this.submitted = true;
    if (this.googleAdsform.invalid) {
      return;
    } else {
      this.setInAppPurchases();
    }
  }

  async setInAppPurchases() {
    const config = {
      ...this.adsConfig,
      ios_ad_google_key: this.googleAdsform.value.ios_ad_google_key
        ? this.googleAdsform.value.ios_ad_google_key
        : this.adsConfig.ios_ad_google_key,
      ios_ad_native_key: this.googleAdsform.value.ios_ad_native_key
        ? this.googleAdsform.value.ios_ad_native_key
        : this.adsConfig.ios_ad_native_key,
      ios_ad_banner_key: this.googleAdsform.value.ios_ad_banner_key
        ? this.googleAdsform.value.ios_ad_banner_key
        : this.adsConfig.ios_ad_banner_key,
    };
    const appInfo = this.indexDBService.getItem("item", "app_info");
    appInfo.onsuccess = (event) => {
      if (appInfo.result) {
        this.app_info = appInfo.result;
        this.app_info["ads_provider"] = this.googleAdsform.value.active
          ? this.googleAdsform.value.provider_id
          : null;
        this.app_info["ads_config_ios"] = {
          ios_cell_count: this.googleAdsform.value.ios_cell_count,
          ios_disable_banner: this.googleAdsform.value.ios_disable_banner
            ? 0
            : 1,
          ios_disable_native: this.googleAdsform.value.ios_disable_native
            ? 0
            : 1,
        };
        this.indexDBService.updateItem("item", this.app_info);

        this.ws.processMethod(
          new SetAdsProviderMethod(
            this.googleAdsform.value.provider_id,
            config,
            this.component_ref
          )
        );
      }
    };
  }

  buttonFunction() {
    this.button_label = this.builderService.getButtonSplashItem(
      this.button,
      "button_label",
      this.data.splashTab.param.splash.style
    );
    if (this.button_label) {
      this.googleAdsform = this.formBuilder.group({
        lableControl: new UntypedFormControl(this.button_label),
      });
    }
  }

  buttonLabel() {
    if (this.f && this.f.lableControl.valid) {
      this.button.button_label = this.f.lableControl.value;
      this.updateButtonData();
    }
  }

  get f() {
    if (this.googleAdsform && this.googleAdsform.controls) {
      return this.googleAdsform.controls;
    }
  }

  colorChange(event) {
    this.button.button_label_color = this.labelColor;
    this.updateButtonData();
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;
    this.data["component_id"] = this.component_id;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "splash" } },
      this.mode,
      true
    );
  }

  enableStripePayment(status) {
    this.googleAdsform.patchValue({
      active: status ? 1 : 0,
    });

    if (status) {
      this.googleAdsform.get("ios_ad_google_key").enable();
      this.googleAdsform.get("ios_ad_native_key").enable();
      this.googleAdsform.get("ios_ad_banner_key").enable();
      this.googleAdsform.get("ios_disable_banner").enable();
      this.googleAdsform.get("ios_disable_native").enable();
      this.googleAdsform.get("ios_cell_count").enable();
    } else {
      this.googleAdsform.get("ios_ad_google_key").disable();
      this.googleAdsform.get("ios_ad_native_key").disable();
      this.googleAdsform.get("ios_ad_banner_key").disable();
      this.googleAdsform.get("ios_disable_banner").disable();
      this.googleAdsform.get("ios_disable_native").disable();
      this.googleAdsform.get("ios_cell_count").disable();
    }
  }

  readFileAsText(file: File): Promise<string> {
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onloadend = (event: any) => resolve(event.target.result);
    });
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.adsProvidersSubscription) {
      this.adsProvidersSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
    if (this.testedMessagingSubscription) {
      this.testedMessagingSubscription.unsubscribe();
    }
    if (this.thirdPartyInfoSubscription) {
      this.thirdPartyInfoSubscription.unsubscribe();
    }
  }
}
